export default "__VITE_ASSET__508b9e65__"